import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "Schedule_Visit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScheduleVisitHomeHealth = _resolveComponent("ScheduleVisitHomeHealth")!
  const _component_ScheduleVisitHomeCare = _resolveComponent("ScheduleVisitHomeCare")!
  const _component_ScheduleVisitHosPal = _resolveComponent("ScheduleVisitHosPal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.options.Application == _ctx.applicationEnum.AgencyCore)
      ? (_openBlock(), _createBlock(_component_ScheduleVisitHomeHealth, {
          key: 0,
          "visit-details": _ctx.options,
          "is-saving": _ctx.isSaving,
          "is-loading": _ctx.isLoading,
          onLoadingChange: _ctx.handleLoadingChange,
          onSavingChange: _ctx.handleSavingChange,
          reassign: _ctx.reassignVisit,
          cancel: _ctx.cancel,
          ok: _ctx.ok,
          preSelectedEmployee: _ctx.selectedEmployee
        }, null, 8 /* PROPS */, ["visit-details", "is-saving", "is-loading", "onLoadingChange", "onSavingChange", "reassign", "cancel", "ok", "preSelectedEmployee"]))
      : _createCommentVNode("v-if", true),
    (_ctx.options.Application == _ctx.applicationEnum.HomeCare)
      ? (_openBlock(), _createBlock(_component_ScheduleVisitHomeCare, {
          key: 1,
          "visit-details": _ctx.options,
          "is-loading": _ctx.isLoading,
          "is-saving": _ctx.isSaving,
          onLoadingChange: _ctx.handleLoadingChange,
          onSavingChange: _ctx.handleSavingChange,
          reassign: _ctx.reassignVisit,
          cancel: _ctx.cancel,
          ok: _ctx.ok,
          "add-another": _ctx.addAnother,
          preSelectedEmployee: _ctx.selectedEmployee
        }, null, 8 /* PROPS */, ["visit-details", "is-loading", "is-saving", "onLoadingChange", "onSavingChange", "reassign", "cancel", "ok", "add-another", "preSelectedEmployee"]))
      : _createCommentVNode("v-if", true),
    (
                _ctx.options.Application == _ctx.applicationEnum.AxxessHospiceFE ||
                _ctx.options.Application == _ctx.applicationEnum.AxxessHospice ||
                _ctx.options.Application == _ctx.applicationEnum.AxxessPalliative
            )
      ? (_openBlock(), _createBlock(_component_ScheduleVisitHosPal, {
          key: 2,
          "visit-details": _ctx.options,
          "is-loading": _ctx.isLoading,
          isSaving: _ctx.isSaving,
          "onUpdate:isSaving": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isSaving) = $event)),
          "employee-list": _ctx.employeeList,
          reassign: _ctx.reassignVisit,
          cancel: _ctx.cancel,
          ok: _ctx.ok,
          preSelectedEmployee: _ctx.selectedEmployee
        }, null, 8 /* PROPS */, ["visit-details", "is-loading", "isSaving", "employee-list", "reassign", "cancel", "ok", "preSelectedEmployee"]))
      : _createCommentVNode("v-if", true)
  ]))
}